import { hasPagePermissions } from 'hooks/hasPagePermissions'
import { NewPermissions } from 'pages/Admin/AdminTools/NewPermissions'
import { PermissionsByRole } from 'pages/Admin/AdminTools/PermissionsByRole'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ButtonGroup } from 'stories/components'

const tabs = {
  type: 'By Permission Type',
  account: 'By Account Type',
}

export const Permissions = () => {
  const location = useLocation()
  const navigate = useHistory()
  const accountAllowed = hasPagePermissions(['admin_tool', 'permissionsByRole'])
  const tabFromSearch = () =>
    new URLSearchParams(location.search).get('tab') === 'account' && accountAllowed ? 'account' : 'type'
  const [tab, setTab] = useState(tabFromSearch)

  useEffect(() => {
    setTab(tabFromSearch())
  }, [location.search])

  const onChange = (next: string) => {
    setTab(next)
    navigate.replace(`/admin_tool/permissions${next === 'account' ? '?tab=account' : ''}`)
  }

  const visibleTabs = accountAllowed ? tabs : { type: tabs.type }

  return (
    <div>
      <ButtonGroup title={visibleTabs} value={tab} onChange={onChange} />
      <div className="mt-4">{tab === 'account' && accountAllowed ? <PermissionsByRole /> : <NewPermissions />}</div>
    </div>
  )
}
